<template>
  <div id="main-content" >
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="dimension" @change="init_data">
          <a-radio-button value="advertiser_id">
            账户
          </a-radio-button>
          <a-radio-button value="app_id">
            产品
          </a-radio-button>
          <a-radio-button value="platform">
            平台
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-select v-model="platform" style="width: 200px" allowClear
                  placeholder="请选择平台"
                  @change="init_data">
          <a-select-option value="iOS" key="ios">iOS</a-select-option>
          <a-select-option value="Android" key="android">Android</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" html-type="submit" >导出</a-button>
      </a-form-item>
      <a-form-item style="float: right">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="init_data()" />
      </a-form-item>
      <a-form-item style="color: red;float: right">
        iOS：唯一时区&nbsp;&nbsp;&nbsp;&nbsp;Android：UTC时区
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }"
             :rowKey="item=>item.date" :loading="tableLoad"
             :data-source="tableData" bordered :pagination="false">
      <span slot="dimension" slot-scope="text" style="cursor: pointer">
        <ApplicationShow v-if="dimension==='app_id'" :application-list="$store.getters.getAppAll" :app-id="text"></ApplicationShow>
        <a-tooltip v-else-if="dimension==='advertiser_id'">
          <template slot="title" >
            {{$store.state.purchaseAccount[text]}}
          </template>
          {{text}}
        </a-tooltip>
        <div v-else>{{text}}</div>
        <!--{{text}}-->
        <!--<img v-if="recode.icon" :src="recode.icon" style="height: 40px;">-->
        <!--<span style="margin-left: 10px;">{{recode.product}}</span>-->
      </span>
    </a-table>
  </div>
</template>

<script>
import {GetPurchaseCheck} from "../../api/v1/purchase_api";
import ApplicationShow from "../../components/V1/ApplicationShow";

export default {
  name: "Check",
  components: {ApplicationShow},
  data(){
    return {
      dimension:'advertiser_id',
      date:['',''],
      platform:'',
      tableLoad:false,
      tableData:[],
      fields:[],
      tableHeight:0,
    }
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        {title: '维度指标',
          width:this.dimension==='app_id'?360:200,
          scopedSlots: { customRender: 'dimension' },
          dataIndex: 'dimension',fixed:'left',align:this.dimension==='app_id'?'left':'center'},
      ]
      this.fields.forEach(item=>{
        _table_columns.push({
          title: item,
          dataIndex: item,
          width: 150,
          align:'center'
        })
      })
      _table_columns.push({title: '汇总',width:150, dataIndex: 'count',fixed:'right',align:'center'})
      return _table_columns
    }
  },
  mounted() {
    this.init_data()
  },
  methods: {
    init_data(){
      GetPurchaseCheck({
        dimension:this.dimension,
        start:this.date[0],
        end:this.date[1],
        platform:this.platform
      }).then(resp => {
        if (resp.code===200){
          this.date = resp.data.date
          this.fields = resp.data.fields
          this.tableData = resp.data.list
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Purchase/Check.vue